import { Capacitor, registerPlugin } from "@capacitor/core";

/*
 * FFCall - native zəng körpüsü (Android: FCM + tam ekran bildiriş, iOS: PushKit + CallKit).
 * Brauzerdə (sayt) heç nə etmir; yalnız Capacitor tətbiqində işləyir.
 */
const FFCall = registerPlugin("FFCall");
const API = "https://ffqadir.az";

export const isNativeApp = () => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

async function postJson(path, body) {
  try {
    await fetch(API + path, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
  } catch (err) {
    console.warn("FFCall sorğu xətası:", err);
  }
}

/** Çalan (cavablanmamış) native zəng ekranını/səsini söndür. */
export const nativeDismiss = () => {
  if (isNativeApp()) FFCall.dismiss().catch(() => { });
};

/** Cavablanmış native zəngi bitir (iOS CallKit). */
export const nativeEnd = () => {
  if (isNativeApp()) FFCall.endCall().catch(() => { });
};

/**
 * role: "user" (ownerId = roomId) | "admin" (ownerId serverdə girişdən götürülür)
 * onAnswered({ roomId, callId, callerRole }): native ekranda "Cavab ver" basılıb
 * onEnded({ roomId }): iOS sistem zəng ekranından zəng bitirilib
 * Qaytarır: təmizləmə funksiyası
 */
export function initNativeCalls({
  role,
  ownerId = "",
  category = "",
  socket,
  onAnswered,
  onEnded,
  onNotificationTapped,
}) {
  if (!isNativeApp()) return () => { };

  let disposed = false;
  const handles = [];

  const register = async () => {
    try {
      const info = await FFCall.register();
      if (disposed) return;
      await postJson("/chatBotApi/api/mobile/device/register", {
        ...info,
        ownerType: role,
        ownerId,
        category,
      });
    } catch (err) {
      console.warn("FFCall register xətası:", err);
    }
  };

  const sendAppState = () => {
    if (!socket) return;
    socket.emit("app_state", {
      state: document.visibilityState === "hidden" ? "background" : "foreground",
    });
  };

  const onConnect = () => {
    sendAppState();
    // Zəng ilə açılan tətbiq: serverə bu socket-in hansı otağa aid olduğunu bildir
    if (role === "user" && ownerId) socket.emit("native_user_ready", { roomId: ownerId });
  };

  (async () => {
    // Dinləyiciləri ƏVVƏL əlavə et ki, "Cavab ver" ilə açılışda hadisə itməsin
    const add = async (name, fn) => {
      try {
        const h = await FFCall.addListener(name, fn);
        if (disposed) h.remove();
        else handles.push(h);
      } catch (err) {
        console.warn("FFCall listener xətası:", name, err);
      }
    };

    await add("callAnswered", (d) => onAnswered && onAnswered(d || {}));
    await add("callEnded", (d) => onEnded && onEnded(d || {}));
    await add("notificationTapped", (d) => onNotificationTapped && onNotificationTapped(d || {}));
    await add("tokenRefresh", register);

    try {
      await FFCall.setConfig({ apiBase: API });
      await FFCall.askPermissions();
    } catch (err) {
      console.warn("FFCall icazə xətası:", err);
    }
    await register();
  })();

  if (socket) {
    socket.on("connect", onConnect);
    if (socket.connected) onConnect();
  }
  document.addEventListener("visibilitychange", sendAppState);

  return () => {
    disposed = true;
    document.removeEventListener("visibilitychange", sendAppState);
    if (socket) socket.off("connect", onConnect);
    handles.forEach((h) => h.remove());
  };
}

/** Android 14+: tam ekran zəng icazəsi söndürülübsə ayarı aç. */
export async function ensureFullScreenCallPermission() {
  if (!isNativeApp()) return;
  try {
    const s = await FFCall.checkState();
    if (s && s.fullScreenIntent === false) await FFCall.openFullScreenIntentSettings();
  } catch { /* ignore */ }
}
